import axios from "axios";
import config from "../config/index";

axios.defaults.withCredentials = true;

// 创建axios实例
const Axios = axios.create({
  baseURL: config.B_BASEURL, // baseUrl
  timeout: 60000, // 超时时间
  transformRequest: [
    function(data) {
      let ret = "";
      // data['app_id'] = config.app_id;
      for (let it in data) {
        ret +=
          encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
      }
      ret = ret.substring(0, ret.lastIndexOf("&"));
      return ret;
    }
  ]
});

// request拦截器
Axios.interceptors.request.use(
  config => {
    return config;
  },
  error => {
    // Do something with request error
    Promise.reject(error);
  }
);

// respone拦截器
Axios.interceptors.response.use(
  response => {
    if (response.data.error_no !== "0") {
      return Promise.resolve(response.data);
    } else {
      return Promise.reject(response.data);
    }
  },
  error => {
    error.message =
      error.message === "Network Error" ? "网络错误" : error.message;

    return Promise.reject(error);
  }
);

export default Axios;
